var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFleches(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 279,
    viewBox: "0 0 291 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91071 173.719C2.82312 158.748 -0.0386345 142.502 0.27934 126.256C0.597314 110.011 4.095 93.7648 10.1365 78.4747C16.178 63.1846 25.3993 48.8502 36.5284 36.4269C47.6575 24.0037 61.3304 13.4918 76.2752 5.5282L84.8605 24.3223C71.1876 29.7375 58.4686 37.7011 47.3395 47.576C36.2104 57.7694 26.6712 69.5555 19.6758 83.2529C5.68488 110.011 0.91527 142.821 7.91071 173.719Z",
    fill: "#B5CD30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6899 40.2495L77.865 16.3587L53.699 6.48382L68.0078 0.431488L92.1739 10.3063L82.3167 34.5157L67.6899 40.2495Z",
    fill: "#B5CD30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.216 6.16528C182.797 9.03218 198.059 14.766 212.05 23.0481C226.041 31.3302 238.442 42.1607 248.935 54.9025C259.11 67.6442 267.378 82.6158 272.783 98.543C278.189 114.47 280.415 131.353 280.097 148.554L260.382 146.962C262.29 132.309 261.654 117.337 258.474 102.684C254.977 88.031 249.253 73.6966 240.986 60.9548C232.719 48.2131 221.907 36.7455 209.506 27.5077C196.787 17.9514 182.479 10.6249 167.216 6.16528Z",
    fill: "#B5CD30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M254.341 124.026L270.239 144.413L290.59 128.168L289 143.776L268.332 160.022L252.433 139.317L254.341 124.026Z",
    fill: "#B5CD30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.898 226.916C226.359 239.658 213.958 250.488 200.285 259.089C186.294 267.371 170.714 273.424 154.179 276.29C137.644 279.157 120.792 278.839 104.257 275.653C87.7223 272.468 71.8236 265.778 57.1968 257.178L68.6439 239.976C80.7269 248.259 94.0818 254.629 108.391 258.77C122.7 262.593 137.644 264.186 152.907 263.23C167.852 261.956 182.797 258.452 197.105 252.4C210.778 246.666 224.133 237.747 235.898 226.916Z",
    fill: "#B5CD30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.902 246.347L65.1461 250.488L69.5977 276.29L56.8787 267.053L52.7451 241.569L78.1831 237.11L90.902 246.347Z",
    fill: "#B5CD30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleches);
export default __webpack_public_path__ + "static/media/fleches.88f29c3c012176f744575c76bda6cc84.svg";
export { ForwardRef as ReactComponent };